import { create } from "zustand"

type BreadcrumbLeafState = {
  /**
   * The leaf is stored WITH the pathname that produced it.
   *
   * A detail page publishes its record's name after the query resolves, and the next route mounts before the
   * old one unmounts — so a leaf cleared on unmount can outlive its page by a frame and label the wrong screen.
   * Keying by pathname makes a stale leaf unreadable rather than merely short-lived.
   */
  pathname: string | null
  label: string | null
  setLeaf: (pathname: string, label: string | null) => void
  clearLeaf: (pathname: string) => void
}

export const useBreadcrumbLeafStore = create<BreadcrumbLeafState>((set) => ({
  pathname: null,
  label: null,
  setLeaf: (pathname, label) => set({ pathname, label }),
  clearLeaf: (pathname) =>
    set((state) => (state.pathname === pathname ? { pathname: null, label: null } : state)),
}))
